import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { Usuario } from '../../models/usuario';
import { AuthService } from '../../shared/auth/auth.service';
import { Router } from '@angular/router';
import { AbConfigSkin } from 'app/abstract/full-pages/config-skin/config-skin.abstract';
import { Subject, takeUntil } from 'rxjs';
import { DesignSystemSigmaService } from 'app/services/design-system-sigma.service';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss'],
})
export class FullLayoutComponent implements OnInit, OnDestroy {
  exibir: Boolean = false;
  bgColor: String = 'azul';
  sidenavCustom: string = '';
  fixednavbar: string = 'fixadosemcor';
  fixedNavPosition: string = 'fixed';
  fixedNavTop: string = '0px';
  distanciaMainContent: string = this.authService.getPrimeiroAcesso() ? '0' : '41px 0 0';
  usuario: Usuario;
  private readonly destroy$ = new Subject();

  constructor(
    private router: Router,
    public authService: AuthService,
    private service: AbConfigSkin,
    private dssService: DesignSystemSigmaService
  ) {}

  ngOnInit() {
    this.dssService.applyTheme();

    if (this.router.url.indexOf('/select-conta') == 0) {
      let cor = sessionStorage.getItem('cor');
      if (cor) {
        this.retornarConfigSkinConta(cor);
      } else {
        this.service
          .getSkinCor()
          .pipe(takeUntil(this.destroy$))
          .subscribe((response) => this.retornarConfigSkinConta(response.cor));
      }
    } else {
      let skin = this.authService.getSkin();
      if (skin) {
        this.retornarConfigSkinConta(skin.cor);
      } else {
        this.service
          .getSkinCor()
          .pipe(takeUntil(this.destroy$))
          .subscribe((response) => this.retornarConfigSkinConta(response.cor));
      }
    }
    this.exibir = true;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollnavbar =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (scrollnavbar <= 2) {
      this.fixednavbar = 'fixadosemcor';
    } else if (scrollnavbar > 2) {
      this.fixednavbar = 'fixadocomcor';
    } else {
      this.fixednavbar = 'fixadosemcor';
    }
  }

  private retornarConfigSkinConta(cor) {
    this.bgColor = cor;
    let arrayBody = document.body.classList;
    for (let i in arrayBody) {
      if (arrayBody.hasOwnProperty(i)) {
        if (arrayBody[i].indexOf('body-') != -1) {
          document.getElementById('body-Center').classList.remove(arrayBody[i]);
          document.getElementById('body-Center').classList.add(arrayBody[i]);
        }
      }
    }

    document.getElementById('body-Center').classList.add('body-' + this.bgColor);
    this.exibir = true;
  }

  isPrimeiroAcesso() {
    return this.authService.getPrimeiroAcesso();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
